import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import NavBar from '../NavBar/Navbar';
import Table from '../Table/Table';
import SmartPayFormModal from '../Modal/Modal';
import ModalDetailNotification from './ModalDetailNotification';
import ClientNotifications from './ClientNotifications';
import SuccessAlert from '../Alerts/SuccessAlert';
import ErrorAlert from '../Alerts/ErrorAlert';
import { NotificationsFetchAPI } from '../../api/Notifications';
import AppShell from '../../page/AppShell/AppShell';
import MainContent from '../MainContent/MainContent';

/* ─────────────────────────────────────────────────────────
   CSS — inyectado una vez. Prefijo: .ntf-
───────────────────────────────────────────────────────── */
const NTF_CSS = `
@keyframes ntf-up   { from{opacity:0;transform:translateY(10px)} to{opacity:1;transform:translateY(0)} }
@keyframes ntf-fade { from{opacity:0} to{opacity:1} }

/* ── page ── */
.ntf-page {
  min-height: 100vh;
  background: var(--bg-3, #F8F8F8);
  padding: 1.5rem clamp(1rem,3vw,2rem) 4rem;
}

/* ── banner ── */
.ntf-banner {
  display: flex; align-items: center; justify-content: space-between;
  flex-wrap: wrap; gap: 1rem;
  background: var(--bg, #fff);
  border: 1.5px solid var(--border, rgba(0,0,0,.07));
  border-radius: 16px;
  padding: 1.1rem 1.35rem;
  margin-bottom: 1.5rem;
  box-shadow: 0 2px 10px rgba(0,0,0,.04);
  animation: ntf-up .3s ease both;
}
.ntf-banner-eyebrow {
  font-size: .68rem; font-weight: 700;
  letter-spacing: .09em; text-transform: uppercase;
  color: #1B3A6B; margin-bottom: .22rem;
}
.ntf-banner-title {
  font-size: 1.15rem; font-weight: 700;
  color: var(--text, #0A0A0A);
  font-family: var(--font-sans, -apple-system, sans-serif);
  letter-spacing: -.02em;
}
.ntf-banner-sub { font-size: .77rem; color: var(--text-3, #B4B4B4); margin-top: .18rem; }

/* ── tabs ── */
.ntf-tabs {
  display: flex; gap: .3rem;
  border-bottom: 1.5px solid var(--border, rgba(0,0,0,.07));
  margin-bottom: 1.35rem;
  overflow-x: auto; scrollbar-width: none;
}
.ntf-tabs::-webkit-scrollbar { display: none; }

.ntf-tab {
  display: inline-flex; align-items: center; gap: .38rem;
  padding: .6rem 1.1rem;
  border: none; background: transparent;
  font-family: var(--font-sans, -apple-system, sans-serif);
  font-size: .82rem; font-weight: 500;
  color: var(--text-2, #6B6B6B);
  cursor: pointer; white-space: nowrap;
  border-bottom: 2px solid transparent;
  margin-bottom: -1.5px;
  transition: color .14s, border-color .14s;
}
.ntf-tab:hover { color: #1B3A6B; }
.ntf-tab.active {
  color: #1B3A6B; font-weight: 700;
  border-bottom-color: #1B3A6B;
}

/* ── section header ── */
.ntf-section-head {
  display: flex; align-items: center; justify-content: space-between;
  flex-wrap: wrap; gap: .75rem;
  margin-bottom: 1.1rem;
}
.ntf-section-title {
  font-size: .9rem; font-weight: 700;
  color: var(--text, #0A0A0A);
  font-family: var(--font-sans, -apple-system, sans-serif);
  display: flex; align-items: center; gap: .4rem;
}
`;

/* ── ICONS ── */
const IcoBell = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" /><path d="M13.73 21a2 2 0 0 1-3.46 0" /></svg>;
const IcoBellSch = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" /><path d="M13.73 21a2 2 0 0 1-3.46 0" /><line x1="12" y1="2" x2="12" y2="4" /></svg>;

/* ════════════════════════════════════════════════════════
   COMPONENT — lógica 100% original
════════════════════════════════════════════════════════ */
const Notifications = () => {

    /* inject CSS once */
    useEffect(() => {
        const id = "ntf-styles";
        if (!document.getElementById(id)) {
            const el = document.createElement("style");
            el.id = id; el.textContent = NTF_CSS;
            document.head.appendChild(el);
        }
    }, []);

    /* ════════════════════════════════════
       LÓGICA ORIGINAL — 100% INTACTA
    ════════════════════════════════════ */
    let { business_code } = useParams();
    let user = JSON.parse(localStorage.getItem('user'));
    let token = localStorage.getItem('x-access-token');

    const [selectedNotification, setSelectedNotification] = useState({
        description: "", secure_url: "", name: "", id: 0, branchoffices: []
    });
    const [userBranchoffices, setUserBranchs] = useState([]);
    const [eventHandler, setEventHandler] = useState(0);
    const [notifications, setNotifications] = useState([]);
    const [formData, setFormData] = useState({});
    const [modalFields, setModalFields] = useState([
        { name: "name", type: "text", label: "Nombre", placeholder: "Ingrese nombre", required: true },
        { name: "description", type: "text", label: "Descripcion", placeholder: "Ingrese descripcion", required: true },
        { name: "files", type: "file", label: "Imagen", placeholder: "Seleccione imagen", required: false },
    ]);
    const [showAddModal, setShowAddModal] = useState(false);
    const [showDetailModal, setShowDetailModal] = useState(false);
    const [showEditNotification, setShowEditNotificationModal] = useState(false);

    const getNotificationsTypes = async (branchoffice_id, business_id) => {
        try {
            const res = await NotificationsFetchAPI.getTypeNotifications(business_id, branchoffice_id, token);
            setNotifications(res.data.notification_types);
        } catch (err) { setNotifications([]); }
    };

    const createNotificationType = async (e) => {
        e.preventDefault();
        try {
            formData.business_id = user.business_id;
            await NotificationsFetchAPI.createNotificationType(formData, token);
            SuccessAlert('Notificacion creada');
            setEventHandler(1);
            setShowAddModal(false);
            setModalFields([
                { name: "name", type: "text", label: "Nombre", placeholder: "Ingrese nombre", required: true },
                { name: "description", type: "text", label: "Descripcion", placeholder: "Ingrese descripcion", required: true },
                { name: "files", type: "file", label: "Imagen", placeholder: "Seleccione imagen", required: false },
            ]);
        } catch (err) {
            console.log(err);
            ErrorAlert('Error al crear la notificacion');
        }
    };

    const getBranchofficesByNotification = async (notification) => {
        try {
            console.log(notification);
            const res = await NotificationsFetchAPI.getBranchofficesByNotificationTypes(notification.id, token);
            setSelectedNotification({
                description: notification.description, secure_url: notification.secure_url,
                name: notification.name, id: notification.id,
                branchoffices: res.data.branchoffices
            });
        } catch (err) {
            setSelectedNotification({
                description: notification.description, secure_url: notification.secure_url,
                name: notification.name, id: notification.id, branchoffices: []
            });
        }
    };

    const editNotificationType = async (e) => {
        e.preventDefault();
        try {
            formData.notification_id = selectedNotification.id;
            await NotificationsFetchAPI.editNotificationType(formData, token);
            SuccessAlert('Notificacion editada');
            setEventHandler(1);
            setShowEditNotificationModal(false);
        } catch (err) { ErrorAlert('Error al editar la notificacion'); }
    };

    const handleFieldChange = (fieldName, value) => {
        setFormData(prevData => ({ ...prevData, [fieldName]: value }));
    };

    useEffect(() => {
        setUserBranchs(user.branchoffices);
        getNotificationsTypes(0, user.business_id);
        setEventHandler(0);
    }, []);

    useEffect(() => {
        getNotificationsTypes(0, user.business_id);
        setEventHandler(0);
    }, [eventHandler]);

    useEffect(() => {
        setFormData({
            name: selectedNotification.name,
            description: selectedNotification.description,
            secure_url: selectedNotification.secure_url,
            branchoffices: selectedNotification.branchoffices
        });
    }, [selectedNotification]);
    /* ════════════════════════════════════
       FIN LÓGICA ORIGINAL
    ════════════════════════════════════ */

    /* ── tab UI state ── */
    const [activeTab, setActiveTab] = useState('types');

    /* ══════════════════════════════════
       RENDER
    ══════════════════════════════════ */
    return (
        <>

            <AppShell route="notifications">
                <MainContent>
                    <div className="ntf-page">

                        {/* ── BANNER ── */}
                        <div className="ntf-banner">
                            <div>
                                <p className="ntf-banner-eyebrow">Gestión</p>
                                <h1 className="ntf-banner-title">Notificaciones</h1>
                                <p className="ntf-banner-sub">Gestión de tipos y envíos de notificaciones</p>
                            </div>
                        </div>

                        {/* ── TABS ── */}
                        <div className="ntf-tabs">
                            <button
                                className={`ntf-tab${activeTab === 'types' ? ' active' : ''}`}
                                onClick={() => setActiveTab('types')}
                            >
                                <IcoBell /> Tipos de Notificaciones
                            </button>
                            <button
                                className={`ntf-tab${activeTab === 'clients' ? ' active' : ''}`}
                                onClick={() => setActiveTab('clients')}
                            >
                                <IcoBellSch /> Notificaciones de clientes
                            </button>
                        </div>

                        {/* ── TAB: tipos de notificaciones ── */}
                        {activeTab === 'types' && (
                            <div style={{ animation: 'ntf-up .25s ease both' }}>
                                <div className="ntf-section-head">
                                    <span className="ntf-section-title">
                                        <IcoBell /> Tipos de notificaciones
                                    </span>

                                    {/* Modal agregar — lógica original intacta */}
                                    <SmartPayFormModal
                                        formType={"addform"}
                                        button_text={"Agregar tipo"}
                                        buttonModal={true}
                                        modal_header_text={"Agregar Notificación"}
                                        modal_body={modalFields}
                                        initialFormValues={modalFields}
                                        setShowModal={setShowAddModal}
                                        showModal={showAddModal}
                                        handleFieldChange={handleFieldChange}
                                        submit={createNotificationType}
                                    />
                                </div>

                                {/* Table — recibe paginación internamente */}
                                <Table
                                    table_headers={['Imagen', 'Nombre', 'Descripcion', 'Acciones']}
                                    table_data={notifications}
                                    table_type={"notification_types_table"}
                                    setShowModal={setShowDetailModal}
                                    setSelectedNotification={setSelectedNotification}
                                    setEditShowModal={setShowEditNotificationModal}
                                    getBranchofficesByNotification={getBranchofficesByNotification}
                                />

                                {/* Modal detalle — lógica original intacta */}
                                <ModalDetailNotification
                                    setShowModal={setShowDetailModal}
                                    showModal={showDetailModal}
                                    notification={selectedNotification}
                                    userBranchoffices={userBranchoffices}
                                    setEventHandler={setEventHandler}
                                    token={token}
                                />

                                {/* Modal editar — lógica original intacta */}
                                <SmartPayFormModal
                                    buttonModal={false}
                                    modal_size={"lg"}
                                    modal_header_text={"Editar notificación"}
                                    modal_body={modalFields}
                                    submit={editNotificationType}
                                    setShowModal={setShowEditNotificationModal}
                                    showModal={showEditNotification}
                                    handleFieldChange={handleFieldChange}
                                    initialFormValues={formData}
                                    formType={"editForm"}
                                />
                            </div>
                        )}

                        {/* ── TAB: notificaciones de clientes ── */}
                        {activeTab === 'clients' && (
                            <div style={{ animation: 'ntf-up .25s ease both' }}>
                                <ClientNotifications
                                    userBranchoffices={userBranchoffices}
                                    business_code={business_code}
                                    token={token}
                                    user={user}
                                />
                            </div>
                        )}

                    </div>
                </MainContent>
            </AppShell>




        </>
    );
};

export default Notifications;